module.exports = __webpack_public_path__ + "08710d9d46e4eea8769cba71877a84fc.pdf";